import PageState from "./state"
import mutations from "./mutations"
import {getModule} from '@/store/store'
let APIS = {
  // 获取活动信息
  getActivityInfo: 'get /apis/moyin-account/moyou/activity/getActivityInfo',
  // 获取二维码
  // getCodeUrl: `/apis/tts-web-api/moyou/activity/codeUrl`,
  getCodeUrl: `/apis/moyin-account/moyou/activity/getAuthUrl`,
  
  // 获取用户状态
  getUsableStatus: {
    custom: true,
    url: (data: any)=>`/apis/moyin-account/moyou/activity/status?activityId=${data.activityId}`,
    method: 'get'
  },
  // 参加活动
  joinActivity: {
    custom: true,
    url: (data: any)=>`/apis/moyin-account/moyou/activity/joinActivity`,
    method: 'get'
  }
}
export default {
  ...getModule({
    state:new PageState(),
    mutations,
    actions:{},
    APIS,
    name:"accredit"
  })
}